import React from 'react';
import { CellProps, isBooleanControl, RankedTester, rankWith, WithClassname } from '@jsonforms/core';
import { withJsonFormsCellProps } from '@jsonforms/react';
import { MantineCheckbox } from '../mantine-controls/MantineCheckbox';

export const MantineBooleanCell = (props: CellProps & WithClassname) => {
  return <MantineCheckbox {...props} />;
};

export const mantineBooleanCellTester: RankedTester = rankWith(2, isBooleanControl);

export default withJsonFormsCellProps(MantineBooleanCell);
